import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getDashboardData = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/ticketdashboard${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export function getTaskStatusGraph( token,id) {
    return axios.get(baseUrl + `/getTaskStatusGraph?project_id=${id}`, {
      headers: {
        Authorization: token,
      },
    });
  };
  export function getTaskPriorityGraph( token,id) {
    return axios.get(baseUrl + `/getTaskPriorityGraph?project_id=${id}`, {
      headers: {
        Authorization: token,
      },
    });
  };
  export function getProjectBudgetVsActual( token,id) {
    return axios.get(baseUrl + `/getProjectBudgetVsActual?project_id=${id}`, {
      headers: {
        Authorization: token,
      },
    });
  };
  export function getTaskTimelineChart( token,id) {
    return axios.get(baseUrl + `/getTaskTimelineChart?project_id=${id}`, {
      headers: {
        Authorization: token,
      },
    });
  };
  
  ///// Arti Apis
  export function getTaskStatusbyProject( token,query) {
    const qs = buildQuery(query);
    return axios.get(baseUrl + `/getTaskStatusbyProject${qs}`, {
      headers: {
        Authorization: token,
      },
    });
  }
  export function getCombinedSecondDashboardData( token) {
    // const qs = buildQuery(query);
    return axios.get(baseUrl + `/getTaskCountbyResource`, {
      headers: {
        Authorization: token,
      },
    });
  }
  
    export function getTileDashboard( token) {
    // const qs = buildQuery(query);
    return axios.get(baseUrl + `/getTileDashboard`, {
      headers: {
        Authorization: token,
      },
    });
  }